module.exports = __webpack_public_path__ + "img/trianglelogo.cea19f9d.png";